/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Announcement, AnnouncementFromJSON, AnnouncementFromJSONTyped, AnnouncementToJSON } from './Announcement'

/**
 *
 * @export
 * @interface GetAnnouncementResponseData
 */
export interface GetAnnouncementResponseData {
  /**
   *
   * @type {Announcement}
   * @memberof GetAnnouncementResponseData
   */
  announcement?: Announcement
}

export function GetAnnouncementResponseDataFromJSON(json: any): GetAnnouncementResponseData {
  return GetAnnouncementResponseDataFromJSONTyped(json, false)
}

export function GetAnnouncementResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAnnouncementResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    announcement: !exists(json, 'announcement') ? undefined : AnnouncementFromJSON(json['announcement'])
  }
}

export function GetAnnouncementResponseDataToJSON(value?: GetAnnouncementResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    announcement: AnnouncementToJSON(value.announcement)
  }
}
